import {Component, Input, OnInit} from '@angular/core';
import { UploadService } from './uploadService.service';
import {CommonUtil} from '../../../utils/common.util';

@Component({
  selector: 'form-upload',
  templateUrl: './upload-file.html',
  styleUrls: ['./upload-file.scss']
})
export class UploadComponent implements OnInit {

  public CURRENT_YEAR = CommonUtil.getCurrentAcademicYear();

  @Input() uploadUrl;
  @Input() acceptFormat;
  @Input() uploadType;

  public showloader = false;
  public displayMessage = '';

  public showAlertSuccess = false;
  public showAlertFailure = false;

  public totalRecord = 0;
  public successCount = 0;
  public failureCount = 0;

  selectedFiles: FileList;
  currentFileUpload: File;

  successData = [];
  failureData = [];
  exportRejectedData = [];
  arrayBuffer: any;
  file: File;
  rejectedFileName = '';

  constructor(private uploadService: UploadService) {
    this.resetPage();
    this.rejectedFileName = 'Rejected_Data_' + this.uploadType;
  }

  ngOnInit() {
  }

  public showAlertSuccessMsg() {
    this.showAlertSuccess = true;
  }
  public showAlertFailureMsg() {
    this.showAlertFailure = true;
  }

  public dismissAlertMessage() {
    this.showAlertSuccess = false;
    this.showAlertFailure = false;
  }

  selectFile(event) {
    this.selectedFiles = event.target.files;
  }

  showMessage(modalName) {
    (<any>$('#' + modalName)).modal({ backdrop: 'static', keyboard: false });
    (<any>$('#' + modalName)).modal('show');
  }

  hideMessage(modalName) {
    (<any>$('#' + modalName)).modal('hide');
  }

  resetPage() {
    this.displayMessage = '';
    this.totalRecord = 0;
    this.successCount = 0;
    this.failureCount = 0;
    this.successData = [];
    this.failureData = [];
    this.exportRejectedData = [];

    $( '#file-upload-id' ).val('');
  }
  upload() {
    this.failureData = [];
    this.exportRejectedData = [];
    this.showloader = true;

    this.currentFileUpload = this.selectedFiles.item(0);
    this.rejectedFileName = 'Rejected_Data_' + this.uploadType;

    console.log('this.cu : ', this.currentFileUpload);
    console.log('this.url : ', this.uploadUrl);
    console.log('this.uplty : ', this.uploadType);

    this.uploadService.pushFileToStorage(this.currentFileUpload, this.uploadUrl, this.uploadType)
      .then(res => {
        const json = JSON.parse(res['body']);
        if (json.success) {
          this.totalRecord = json.data.successDataCount + json.data.failureDataCount;
          this.successCount = json.data.successDataCount;
          this.failureCount = json.data.failureDataCount;

          this.successData = json.data.successData;
          this.failureData = json.data.failureData;
          for (let iterate = 0; iterate < this.failureData.length; iterate++) {
            switch (this.uploadType) {
              case 'student':
                this.exportRejectedData.push({
                  student_name : this.failureData[iterate].student_name || '',
                  dob : this.failureData[iterate].dob || '',
                  blood_group : this.failureData[iterate].blood_group || '',

                  register_number : this.failureData[iterate].register_number || '',
                  roll_number : this.failureData[iterate].roll_number || '',
                  community : this.failureData[iterate].community || '',
                  address : this.failureData[iterate].address || '',
                  city : this.failureData[iterate].city || '',
                  pincode : this.failureData[iterate].pincode || '',
                  contact_number : this.failureData[iterate].contact_number || '',
                  aadhar_number : this.failureData[iterate].aadhar_number || '',
                  emergency_mobile : this.failureData[iterate].emergency_mobile || '',

                  class_name : this.failureData[iterate].class_name || '',
                  section_name : this.failureData[iterate].section_name || '',
                  medical_condition : this.failureData[iterate].medical_condition || '',

                  father_name : this.failureData[iterate].father_name || '',
                  father_occupation : this.failureData[iterate].father_occupation || '',
                  father_email : this.failureData[iterate].father_email || '',
                  father_mobile : this.failureData[iterate].father_mobile || '',
                  father_phone : this.failureData[iterate].father_phone || '',
                  father_office_address : this.failureData[iterate].father_office_address || '',

                  mother_name : this.failureData[iterate].mother_name || '',
                  mother_occupation : this.failureData[iterate].mother_occupation || '',
                  mother_email : this.failureData[iterate].mother_email || '',
                  mother_mobile : this.failureData[iterate].mother_mobile || '',
                  mother_phone : this.failureData[iterate].mother_phone || '',
                  mother_office_address : this.failureData[iterate].mother_office_address || '',

                  validationRemarks : this.failureData[iterate].validationRemarks || '',
                  add_update_remarks : this.failureData[iterate].add_update_remarks || ''
                }); break;
              case 'staff':
                this.exportRejectedData.push({
                  'Emp Id': this.failureData[iterate].emp_id || '',
                  'Staff Name': this.failureData[iterate].staff_name || '',
                  'Email': this.failureData[iterate].email || '',
                  'Add/Update Remarks': this.failureData[iterate].add_update_remarks || '',
                  'Validation Remarks': this.failureData[iterate].validationRemarks || ''
                }); break;
              case 'nt-staff':
                this.exportRejectedData.push({
                  'Emp Id': this.failureData[iterate].emp_id || '',
                  'Staff Name': this.failureData[iterate].staff_name || '',
                  'Email': this.failureData[iterate].email || '',
                  'Add/Update Remarks': this.failureData[iterate].add_update_remarks || '',
                  'Validation Remarks': this.failureData[iterate].validationRemarks || ''
                }); break;
              case 'Holiday':
                this.exportRejectedData.push({
                  'Name': this.failureData[iterate].name || '',
                  'Add/Update Remarks': this.failureData[iterate].add_update_remarks || '',
                  'Validation Remarks': this.failureData[iterate].validationRemarks || ''
                }); break;
              case 'Events':
                this.exportRejectedData.push({
                  'Event Name': this.failureData[iterate].name || '',
                  'Description': this.failureData[iterate].description || '',
                  'Add/Update Remarks': this.failureData[iterate].add_update_remarks || '',
                  'Validation Remarks': this.failureData[iterate].validationRemarks || ''
                }); break;
              case 'studentAttn':
                this.exportRejectedData.push({
                  'Class Name': this.failureData[iterate].class_name || '',
                  'Section Name': this.failureData[iterate].section_name || '',
                  'First Name': this.failureData[iterate].first_name || '',
                  'Last Name': this.failureData[iterate].last_name || '',
                  'Add/Update Remarks': this.failureData[iterate].add_update_remarks || '',
                  'Validation Remarks': this.failureData[iterate].validationRemarks || ''
                }); break;
              case 'staffAttn':
                this.exportRejectedData.push({
                  'Emp Id': this.failureData[iterate].emp_id || '',
                  'First Name': this.failureData[iterate].first_name || '',
                  'Last Name': this.failureData[iterate].last_name || '',
                  'Add/Update Remarks': this.failureData[iterate].add_update_remarks || '',
                  'Validation Remarks': this.failureData[iterate].validationRemarks  || ''
                }); break;
              case 'class_fee':
                this.exportRejectedData.push({
                  'Class Name': this.failureData[iterate].class_name || '',
                  'Amount': this.failureData[iterate].amount || '',
                  'Order Id': this.failureData[iterate].order_id || '',
                  'Add/Update Remarks': this.failureData[iterate].add_update_remarks || '',
                  'Validation Remarks': this.failureData[iterate].validationRemarks  || ''
                }); break;
              case 'enquiry':
                this.exportRejectedData.push({
                  'Student Name': this.failureData[iterate].student_name || '',
                  'Email': this.failureData[iterate].email || '',
                  'Emergency Mobile': this.failureData[iterate].emergency_mobile || '',
                  'Father Name': this.failureData[iterate].father_name || '',
                  'Father Mobile': this.failureData[iterate].father_mobile || '',
                  'Father Email': this.failureData[iterate].father_email || '',
                  'Mother Name': this.failureData[iterate].mother_name || '',
                  'Mother Mobile': this.failureData[iterate].mother_mobile || '',
                  'Mother Email': this.failureData[iterate].mother_email || '',
                  'Add/Update Remarks': this.failureData[iterate].add_update_remarks || '',
                  'Validation Remarks': this.failureData[iterate].validationRemarks || ''
                }); break;
              case 'chapter':
                this.exportRejectedData.push({
                  'Chapter Name': this.failureData[iterate].chapter_name || '',
                  'Order id': this.failureData[iterate].order_id || '',
                  'Add/Update Remarks': this.failureData[iterate].add_update_remarks || '',
                  'Validation Remarks': this.failureData[iterate].validationRemarks || ''
                }); break;
              case 'objQuestions':
                this.exportRejectedData.push({
                  'Question' : this.failureData[iterate]['Question'] || '',
                  'Option 1' : this.failureData[iterate]['Option 1'] || '',
                  'Option 2' : this.failureData[iterate]['Option 2'] || '',
                  'Option 3' : this.failureData[iterate]['Option 3'] || '',
                  'Option 4' : this.failureData[iterate]['Option 4'] || '',
                  'Answer Option(1,2,3,4)' : this.failureData[iterate]['Answer Option(1,2,3,4)'] || '',
                  'Order ID': this.failureData[iterate]['order_id'] || '',
                  'Add/Update Remarks': this.failureData[iterate].add_update_remarks || '',
                  'Validation Remarks': this.failureData[iterate].validationRemarks || '',
                }); break;
              case 'studentTermFee':
                this.exportRejectedData.push({
                  term_name: this.failureData[iterate].term_name || '',
                  due_date: this.failureData[iterate].due_date || '',
                  class_name: this.failureData[iterate].class_name || '',
                  section_name: this.failureData[iterate].section_name || '',
                  student_id : this.failureData[iterate].student_id || '',
                  roll_number : this.failureData[iterate].roll_number || '',
                  register_number : this.failureData[iterate].register_number || '',
                  student_name : this.failureData[iterate].student_name || '',
                  'is_paid(yes/no)' : this.failureData[iterate].is_paid || '',
                  'Add/Update Remarks': this.failureData[iterate].add_update_remarks || '',
                  'Validation Remarks': this.failureData[iterate].validationRemarks || '',
                }); break;
              case 'studentExamResults':
                this.exportRejectedData.push({
                  student_id : this.failureData[iterate].student_id || '',
                  first_name : this.failureData[iterate].first_name || '',
                  last_name : this.failureData[iterate].last_name || '',
                  mark : this.failureData[iterate].mark || '',
                  'Add/Update Remarks': this.failureData[iterate].add_update_remarks || '',
                  'Validation Remarks': this.failureData[iterate].validationRemarks || '',
                }); break;
              default:
                this.exportRejectedData.push({
                  'Add/Update Remarks': this.failureData[iterate].add_update_remarks || '',
                  'Validation Remarks': this.failureData[iterate].validationRemarks || ''
                }); break;
            }
          }
          $( '#file-upload-id' ).val('');
          this.showloader = false;
        } else {
          this.resetPage();
          this.showloader = false;
          this.displayMessage = json.error;
          this.showAlertFailureMsg();
          // this.showMessage('messageModel');
        }
    }).catch((err) => {
      this.displayMessage = (JSON.parse(err.error)).error.message;
      this.showAlertFailureMsg();
      // this.showMessage('messageModel');
      this.showloader = false;
    });

    // this.uploadService.pushFileToStorage(this.currentFileUpload, this.uploadUrl, this.uploadType)
    //   .subscribe(res => {
    //     console.log(res);
    //     if(res.status !=500 && res.hasOwnProperty('partialText')) {
    //     let json = JSON.parse(res['partialText']);
    //     if (json.success) {
    //       this.totalRecord = json.data.successDataCount + json.data.failureDataCount;
    //       this.successCount = json.data.successDataCount;
    //       this.failureCount = json.data.failureDataCount;
    //
    //       this.successData = json.data.successData;
    //       this.failureData = json.data.failureData;
    //       for (let iterate = 0; iterate < this.failureData.length; iterate++) {
    //         switch (this.uploadType) {
    //           case 'student':
    //             this.exportRejectedData.push({
    //               first_name : this.failureData[iterate].first_name || '',
    //               last_name : this.failureData[iterate].last_name || '',
    //               dob : this.failureData[iterate].dob || '',
    //               blood_group : this.failureData[iterate].blood_group || '',
    //
    //               register_number : this.failureData[iterate].register_number || '',
    //               roll_number : this.failureData[iterate].roll_number || '',
    //               community : this.failureData[iterate].community || '',
    //               door_no : this.failureData[iterate].door_no || '',
    //               street : this.failureData[iterate].street || '',
    //               area : this.failureData[iterate].area || '',
    //               city : this.failureData[iterate].city || '',
    //               pincode : this.failureData[iterate].pincode || '',
    //               contact_number : this.failureData[iterate].contact_number || '',
    //               aadhar_number : this.failureData[iterate].aadhar_number || '',
    //               emergency_mobile : this.failureData[iterate].emergency_mobile || '',
    //
    //               class_name : this.failureData[iterate].class_name || '',
    //               section_name : this.failureData[iterate].section_name || '',
    //               medical_condition : this.failureData[iterate].medical_condition || '',
    //
    //               father_first_name : this.failureData[iterate].father_first_name || '',
    //               father_last_name : this.failureData[iterate].father_last_name || '',
    //               father_occupation : this.failureData[iterate].father_occupation || '',
    //               father_email : this.failureData[iterate].father_email || '',
    //               father_mobile : this.failureData[iterate].father_mobile || '',
    //               father_phone : this.failureData[iterate].father_phone || '',
    //               father_office_address : this.failureData[iterate].father_office_address || '',
    //
    //               mother_first_name : this.failureData[iterate].mother_first_name || '',
    //               mother_last_name : this.failureData[iterate].mother_last_name || '',
    //               mother_occupation : this.failureData[iterate].mother_occupation || '',
    //               mother_email : this.failureData[iterate].mother_email || '',
    //               mother_mobile : this.failureData[iterate].mother_mobile || '',
    //               mother_phone : this.failureData[iterate].mother_phone || '',
    //               mother_office_address : this.failureData[iterate].mother_office_address || '',
    //
    //               validationRemarks : this.failureData[iterate].validationRemarks || '',
    //               add_update_remarks : this.failureData[iterate].add_update_remarks || ''
    //             }); break;
    //           case 'staff':
    //             this.exportRejectedData.push({
    //               'Emp Id': this.failureData[iterate].emp_id || '',
    //               'First Name': this.failureData[iterate].first_name || '',
    //               'Last Name': this.failureData[iterate].last_name || '',
    //               'Email': this.failureData[iterate].email || '',
    //               'Add/Update Remarks': this.failureData[iterate].add_update_remarks || '',
    //               'Validation Remarks': this.failureData[iterate].validationRemarks || ''
    //             }); break;
    //           case 'nt-staff':
    //             this.exportRejectedData.push({
    //               'Emp Id': this.failureData[iterate].emp_id || '',
    //               'First Name': this.failureData[iterate].first_name || '',
    //               'Last Name': this.failureData[iterate].last_name || '',
    //               'Email': this.failureData[iterate].email || '',
    //               'Add/Update Remarks': this.failureData[iterate].add_update_remarks || '',
    //               'Validation Remarks': this.failureData[iterate].validationRemarks || ''
    //             }); break;
    //           case 'Holiday':
    //             this.exportRejectedData.push({
    //               'Name': this.failureData[iterate].name || '',
    //               'Add/Update Remarks': this.failureData[iterate].add_update_remarks || '',
    //               'Validation Remarks': this.failureData[iterate].validationRemarks || ''
    //             }); break;
    //           case 'Events':
    //             this.exportRejectedData.push({
    //               'Event Name': this.failureData[iterate].name || '',
    //               'Description': this.failureData[iterate].description || '',
    //               'Add/Update Remarks': this.failureData[iterate].add_update_remarks || '',
    //               'Validation Remarks': this.failureData[iterate].validationRemarks || ''
    //             }); break;
    //           case 'studentAttn':
    //             this.exportRejectedData.push({
    //               'Class Name': this.failureData[iterate].class_name || '',
    //               'Section Name': this.failureData[iterate].section_name || '',
    //               'First Name': this.failureData[iterate].first_name || '',
    //               'Last Name': this.failureData[iterate].last_name || '',
    //               'Add/Update Remarks': this.failureData[iterate].add_update_remarks || '',
    //               'Validation Remarks': this.failureData[iterate].validationRemarks || ''
    //             }); break;
    //           case 'staffAttn':
    //             this.exportRejectedData.push({
    //               'Emp Id': this.failureData[iterate].emp_id || '',
    //               'First Name': this.failureData[iterate].first_name || '',
    //               'Last Name': this.failureData[iterate].last_name|| '',
    //               'Add/Update Remarks': this.failureData[iterate].add_update_remarks || '',
    //               'Validation Remarks': this.failureData[iterate].validationRemarks  || ''
    //             }); break;
    //           case 'class_fee':
    //             this.exportRejectedData.push({
    //               'Class Name': this.failureData[iterate].class_name || '',
    //               'Amount': this.failureData[iterate].amount || '',
    //               'Order Id': this.failureData[iterate].order_id || '',
    //               'Add/Update Remarks': this.failureData[iterate].add_update_remarks || '',
    //               'Validation Remarks': this.failureData[iterate].validationRemarks  || ''
    //             }); break;
    //           case 'enquiry':
    //             this.exportRejectedData.push({
    //               'Student Name': this.failureData[iterate].student_name || '',
    //               'Email': this.failureData[iterate].email || '',
    //               'Emergency Mobile': this.failureData[iterate].emergency_mobile || '',
    //               'Father Name': this.failureData[iterate].father_name || '',
    //               'Father Mobile': this.failureData[iterate].father_mobile || '',
    //               'Father Email': this.failureData[iterate].father_email || '',
    //               'Mother Name': this.failureData[iterate].mother_name || '',
    //               'Mother Mobile': this.failureData[iterate].mother_mobile || '',
    //               'Mother Email': this.failureData[iterate].mother_email || '',
    //               'Add/Update Remarks': this.failureData[iterate].add_update_remarks || '',
    //               'Validation Remarks': this.failureData[iterate].validationRemarks || ''
    //             }); break;
    //           case 'chapter':
    //             this.exportRejectedData.push({
    //               'Chapter Name': this.failureData[iterate].chapter_name || '',
    //               'Order id': this.failureData[iterate].order_id || '',
    //               'Add/Update Remarks': this.failureData[iterate].add_update_remarks || '',
    //               'Validation Remarks': this.failureData[iterate].validationRemarks || ''
    //             }); break;
    //           case 'objQuestions':
    //             this.exportRejectedData.push({
    //               'Question' : this.failureData[iterate]['Question'] || '',
    //               'Option 1' : this.failureData[iterate]['Option 1'] || '',
    //               'Option 2' : this.failureData[iterate]['Option 2'] || '',
    //               'Option 3' : this.failureData[iterate]['Option 3'] || '',
    //               'Option 4' : this.failureData[iterate]['Option 4'] || '',
    //               'Answer Option(1,2,3,4)' : this.failureData[iterate]['Answer Option(1,2,3,4)'] || '',
    //               'Order ID': this.failureData[iterate]['order_id'] || '',
    //               'Add/Update Remarks': this.failureData[iterate].add_update_remarks || '',
    //               'Validation Remarks': this.failureData[iterate].validationRemarks || '',
    //             }); break;
    //           default:
    //             this.exportRejectedData.push({
    //               'Add/Update Remarks': this.failureData[iterate].add_update_remarks || '',
    //               'Validation Remarks': this.failureData[iterate].validationRemarks || ''
    //             }); break;
    //         }
    //       }
    //       $( "#file-upload-id" ).val("");
    //       this.showloader = false;
    //     } else {
    //       this.resetPage();
    //       this.showloader = false;
    //       this.displayMessage = json.error;
    //       this.showMessage('messageModel');
    //     }
    //   }
    //   else {
    //     // this.resetPage();
    //     this.showloader = false;
    //     this.displayMessage = res.error;
    //     this.showMessage('messageModel');
    //   }
    //
    // });
  }
}
